import * as z from "zod";
import { SearchResultItem } from "./search-receivable-shipments";

export const listReceivableShipments = {
  name: "listReceivableShipments" as const,
  input: z.object({ locationId: z.string() }),
  output: z.object({ results: z.array(SearchResultItem) }),
};
